export default "__VITE_ASSET__DkM33QDl__"